// 3_pages/thank_you.js
// Moves the order thank-you summary (.summary-thx) above the page <h1> on the
// thank-you page (body.id--15).

export function init() {
	if (!document.body.classList.contains("id--15")) return;

	try {
		sessionStorage.removeItem("natCheckoutShippingMethod");
		sessionStorage.removeItem("natCheckoutPaymentMethod");
	} catch (error) {
		console.warn("Could not clear checkout method selection:", error);
	}

	const thxElement = document.querySelector(".summary-thx");
	if (!thxElement) return;

	const h1Element = document.querySelector("h1");
	if (h1Element) {
		h1Element.insertAdjacentElement("beforebegin", thxElement);
	}
}
